import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Client } from '@df/core/service/client';
import { WishlistQtyComponentDef } from '@df/session/wishlist/wishlist-qty.component.def';
@Component({
    selector: 'wishlist-qty',
    templateUrl: './wishlist-qty.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, RouterLink]
})
export class WishlistQtyComponent extends WishlistQtyComponentDef {
    client = inject(Client);
}
